import React, { Component, createRef } from "react";
import { View, Image, Text, TouchableOpacity, Dimensions } from "react-native";

import { ANIMATION_DURATION, QuestionKind } from "consts";
import {
  Background,
  Card,
  NavButton,
  ScrollView,
  Modal,
  Button,
  Slider,
  Loader,
} from "components";

import Items from "./items";
import Section from "./section";
import { styles } from "./styles";

class Layout extends Component {
  scroll = createRef();

  constructor(props) {
    super(props);
    this.state = {
      section: props.section,
      response: props.response,
      shouldShowAnswer: props.shouldShowAnswer,
      inTransition: false,
    };
  }

  componentDidMount = () => {
    this.setState({
      section: this.props.section,
    });

    Dimensions.addEventListener("change", this.reloadStyles);
  };

  componentWillUnmount = () => {
    Dimensions.removeEventListener("change", this.reloadStyles);
  };

  reloadStyles = () => this.forceUpdate();

  setScrollIndicators = () => {
    if (this.scroll.current) {
      this.scroll.current.triggerSetIndicatorVisibility();
    }
  };

  updateCardState = ({ section, response, shouldShowAnswer }) => {
    this.scroll.current && this.scroll.current.resetIndicatorVisibility();
    setTimeout(() => {
      this.setState(
        {
          section,
          response,
          shouldShowAnswer,
          inTransition: false,
        },
        this.setScrollIndicators,
      );
    }, ANIMATION_DURATION / 2);
  };

  componentDidUpdate = prevProps => {
    const { section, response, sequence, shouldShowAnswer } = this.props;
    const {
      response: prevResponse,

      shouldShowAnswer: prevShouldShowAnswer,
      inTransition,
    } = this.state;

    if (prevProps.sequence !== sequence) {
      this.setState({ inTransition: true }, () =>
        this.updateCardState({ section, response, shouldShowAnswer }),
      );
    } else if (
      (response !== prevResponse ||
        shouldShowAnswer !== prevShouldShowAnswer) &&
      !inTransition
    ) {
      this.setState({ response, shouldShowAnswer });
    }
  };

  render = () => {
    const { background, logo, modal, hideModal, isQuiz } = this.props;
    const {
      navForward,
      navBackward,
      isValid,
      submitFeedback,
      is_submit_clicked,
      feedbackStatus,
    } = this.props;
    const { section, response, inTransition } = this.state;
    const { shouldShowAnswer } = this.state;

    const overriddenProps =
      inTransition || shouldShowAnswer
        ? {
            navForward: () => {},
            navBackward: () => {},
            selectOption: () => {},
            selectSubOption: () => {},
            selectLanguage: () => {},
            setConsent: () => {},
          }
        : {
            navForward,
            navBackward,
            selectOption: this.props.selectOption,
            selectSubOption: this.props.selectSubOption,
          };

    overriddenProps.section = section;
    overriddenProps.response = response;
    overriddenProps.shouldShowAnswer = shouldShowAnswer;
    overriddenProps.scrollDownBy = this.scroll.current?.scrollDownBy;
    overriddenProps.scrollToEnd = this.scroll.current?.scrollToEnd;

    const hideFinishSurvey = section.questions.some(
      q =>
        q.is_required ||
        q.kind === QuestionKind.ASSIGNEE ||
        q.kind === QuestionKind.DESCRIPTION,
    );

    if (is_submit_clicked && !("message" in feedbackStatus)) {
      return <Loader />;
    }

    return (
      <Background style={styles.background} image={background}>
        <Slider style={styles.slider} sequence={this.props.sequence}>
          <Card style={styles.card}>
            <View style={styles.headerContainer}>
              {!hideFinishSurvey && (
                <TouchableOpacity style={styles.finishSurvey}>
                  <Text
                    style={styles.finishSurveyText}
                    onPress={() => submitFeedback(false)}
                  >
                    Finish Survey
                  </Text>
                </TouchableOpacity>
              )}
              <Image
                source={{ uri: logo }}
                style={styles.logo}
                resizeMode="contain"
              />
            </View>
            <View style={styles.contentContainer}>
              <ScrollView ref={this.scroll}>
                <Section {...this.props} {...overriddenProps} />
              </ScrollView>
            </View>
            {this.renderFooter()}
          </Card>
        </Slider>
        {!isQuiz && (
          <>
            <NavButton
              left
              onPress={overriddenProps.navBackward}
              hide={this.props.autoStart && section._index === 0}
            />
            <NavButton
              right
              disabled={is_submit_clicked || !isValid}
              onPress={overriddenProps.navForward}
            />
          </>
        )}
        <Items />
        <Modal visible={modal.visible}>
          <View style={styles.modal}>
            <Text style={styles.message}>{modal.message}</Text>
            <TouchableOpacity style={styles.button} onPress={() => hideModal()}>
              <Text style={styles.buttonText}>Okay</Text>
            </TouchableOpacity>
          </View>
        </Modal>
      </Background>
    );
  };

  renderFooter = () => {
    const { isValid, navForward } = this.props;
    const { showCorrectAnswer } = this.props;
    const { shouldShowAnswer, inTransition } = this.state;

    if (!this.props.isQuiz) {
      return;
    }

    const buttonText = shouldShowAnswer ? "PROCEED" : "   CHECK   ";
    const onPress = shouldShowAnswer ? navForward : showCorrectAnswer;

    return (
      <View>
        <Button
          onPress={inTransition ? () => {} : onPress}
          text={buttonText}
          disabled={!isValid}
          color={styles._quizButton?.color}
          background={styles._quizButton?.backgroundColor}
        />
      </View>
    );
  };
}
export default Layout;
